import { render, staticRenderFns } from "./AllScreen.vue?vue&type=template&id=21808532&scoped=true"
import script from "./AllScreen.vue?vue&type=script&lang=ts"
export * from "./AllScreen.vue?vue&type=script&lang=ts"
import style0 from "./AllScreen.vue?vue&type=style&index=0&id=21808532&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21808532",
  null
  
)

export default component.exports